import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const getWarrantyAdminJobById = (id) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/warranties/task/${id}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_TWC_WARRANTIES_ADMIN_JOB,
        ActionTypes.FETCHED_TWC_WARRANTIES_ADMIN_JOB,
        [ActionTypes.FETCHED_TWC_WARRANTIES_ADMIN_JOB_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};


export const getWarrantyAdminSubcontractList = () => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/warranties/subcontract-types',
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_TWC_WARRANTIES_ADMIN_SUBCONTRACT_LIST,
        ActionTypes.FETCHED_TWC_WARRANTIES_ADMIN_SUBCONTRACT_LIST,
        [ActionTypes.FETCHED_TWC_WARRANTIES_ADMIN_SUBCONTRACT_LIST_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};


export const getWarrantyAdminPart = (part) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/warranties/part/${part}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_TWC_WARRANTIES_ADMIN_PART,
        [
          () => {
            return {
              'type': ActionTypes.FETCHED_TWC_WARRANTIES_ADMIN_PART,
            };
          },
        ],
        [ActionTypes.FETCHED_TWC_WARRANTIES_ADMIN_PART_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const clearSearchPartWarrantyAdmin = () => ({
  'type': ActionTypes.CLEAR_SEARCH_PART_WARRANTY_ADMIN,
});
